import { FadeInUp } from '../animations';

const process = [
  { step: '01', title: 'Requirement' },
  { step: '02', title: 'Manufacturer Identification' },
  { step: '03', title: 'Quotation & Comparison' },
  { step: '04', title: 'Sample / Approval' },
  { step: '05', title: 'Production Coordination' },
  { step: '06', title: 'Quality Check' },
  { step: '07', title: 'Packing & Shipment' },
];

const ProcessSection = () => (
  <section className="py-24 lg:py-32 bg-white" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <FadeInUp className="text-center mb-16">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#0B2A57] mb-4" style={{ fontFamily: 'Cabinet Grotesk' }}>
          FROM REQUIREMENT TO SHIPMENT.
        </h2>
      </FadeInUp>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4">
        {process.map((item, i) => (
          <FadeInUp key={item.step} delay={i * 0.05}>
            <div className="text-center relative" data-testid={`process-step-${i}`}>
              <div className="text-3xl font-bold text-[#0B2A57]/10 mb-2" style={{ fontFamily: 'Cabinet Grotesk' }}>{item.step}</div>
              <div className="w-3 h-3 rounded-full bg-[#0B2A57] mx-auto mb-3" />
              {i < process.length - 1 && (
                <div className="hidden lg:block absolute top-[2.8rem] left-[60%] right-[-40%] h-px bg-[#E5E0D8]" />
              )}
              <p className="text-xs font-semibold text-[#0B2A57] tracking-wide uppercase leading-tight">{item.title}</p>
            </div>
          </FadeInUp>
        ))}
      </div>
    </div>
  </section>
);

export default ProcessSection;
